// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"e0-z"};